import PropTypes from "prop-types";
import { connectStateResults } from "react-instantsearch-dom";

import { jjLogger } from "utils/logUtils";

const LoadingIndicator = ({ searching, loading, searchResults, children, loggerData }) => {
  if (!searching && !loading && searchResults?.nbHits === 0) {
    jjLogger.logError(`AlgoliaSearchResults is empty. ${JSON.stringify(loggerData)}`);
  }

  if (!searching && !loading && searchResults?.nbHits > 0) return null;
  return children;
};

LoadingIndicator.propTypes = {
  searching: PropTypes.bool,
  loading: PropTypes.bool,
  searchResults: PropTypes.shape(),
  loggerData: PropTypes.shape(),
};

const AlgoliaLoadingIndicator = connectStateResults(LoadingIndicator);

export default AlgoliaLoadingIndicator;
